// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"ai-tool"},"children":[{"tag":"g","attrs":{"id":"fill1"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M3 14H10V21H3V14Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M14 14H21V21H14V14Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M3 3H10V10H3V3Z"}}]},{"tag":"g","attrs":{"id":"stroke1"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M3 14H10V21H3V14Z","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M14 14H21V21H14V14Z","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M3 3H10V10H3V3Z","strokeWidth":"props.strokeWidth"}}]},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M18 3.75L18.7 5.29996L20.25 6L18.7 6.70004L18 8.25L17.3 6.70004L15.75 6L17.3 5.29996L18 3.75Z","strokeWidth":"props.strokeWidth"}}]}]};

const AiToolIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'ai-tool',
    ref,
    icon: element,
  },
));

AiToolIcon.displayName = 'AiToolIcon';

export default AiToolIcon;
